const STORAGE_KEY = "tutoria.auth.bearer";

let memoryToken: string | null = null;

function readStored(): string | null {
  try {
    return window.localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

export function getBearerToken(): string | null {
  if (memoryToken) return memoryToken;
  memoryToken = readStored();
  return memoryToken;
}

export function hasBearerToken(): boolean {
  return getBearerToken() != null;
}

export function setBearerToken(token: string): void {
  const normalized = token.trim();
  if (normalized.length === 0) return;
  memoryToken = normalized;
  try {
    window.localStorage.setItem(STORAGE_KEY, normalized);
  } catch {
    // Private browsing etc. — memory token still works for this tab.
  }
}

export function clearBearerToken(): void {
  memoryToken = null;
  try {
    window.localStorage.removeItem(STORAGE_KEY);
  } catch {
    // Nothing to clean up.
  }
}

export function captureSessionTokenFromResponse(response: Response | undefined): void {
  const token = response?.headers.get("set-auth-token");
  if (token) setBearerToken(token);
}

type SignInResponseData = {
  token?: unknown;
  session?: { token?: unknown };
};

/**
 * Primary bearer capture: email sign-in/up return `{ token: sessionToken }`
 * in the JSON body, which — unlike the `set-auth-token` header — is always
 * readable cross-origin. The header is kept as a fallback.
 */
export function captureSessionTokenFromData(data: unknown): void {
  if (!data || typeof data !== "object") return;
  const candidate =
    (data as SignInResponseData).token ?? (data as SignInResponseData).session?.token;
  if (typeof candidate === "string" && candidate.length > 0) {
    setBearerToken(candidate);
  }
}
